/* @ngInject */
const myCommandeDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myCommande: '=',
      myWagons: '=',
      enableButtons: '=?',
      enableTitle: '=?',
      enableLinks: '=?',
      enableBack: '=?',
    },
    template: require('./myCommandeDisplay.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myCommandeDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/directives/display/myCommandeDisplay.js